import React from 'react';

const InstructionStep: React.FC = () => {
    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
                Atualização de Cadastro
            </h2>
            <div className="text-gray-600 space-y-4">
                <p>
                    Olá! É importante manter seus dados sempre atualizados em nosso sistema.
                </p>
                <p>
                    Este processo levará apenas alguns minutos e nos ajudará a garantir que todas as informações estejam corretas para:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>Processamento correto da folha de pagamento</li>
                    <li>Contato em caso de emergência</li>
                    <li>Envio de benefícios e brindes</li>
                    <li>Conformidade com as políticas da empresa</li>
                </ul>
                <div className="bg-blue-50 p-4 rounded-md border-l-4 border-blue-400">
                    <p className="text-blue-800 font-medium">
                        💡 Dica: Você pode salvar seu progresso a qualquer momento. Caso precise interromper, poderá continuar de onde parou.
                    </p>
                </div>
                <p>
                    Clique em <strong>"Salvar e Continuar"</strong> quando estiver pronto para começar.
                </p>
            </div>
        </div>
    );
};

export default InstructionStep;
